import { Injectable } from '@angular/core';

import { FullActivity, FullCategory } from '../../../state/category/category.query';

@Injectable({
  providedIn: 'root',
})
export class ForecastTableGridRemainingService {
  parseCategoryRemaining(category: FullActivity | FullCategory): number {
    return (category.BUDGET_PRIMARY?.total_cost || 0) - (category.BUDGET_PRIMARY?.total_wp || 0);
  }
}
